var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user !== null)?_c('div',[_vm._t("default",null,{"remove":_vm.remove,"is_following":_vm.is_following})],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }